import * as React from 'react';

import '../css/gradient-select.scss';
import { ReactComponent as ArrowDownIcon } from '../icons/icon-arrow-down.svg';
import { processLayoutBlocks } from '../resources/worksheets';

export const SHOW_ALL_QUESTIONS = 'ALL';
export const SHOW_ONLY_PINNED = 'PINNED';
export const SHOW_WORKBOOK = 'WORKBOOK';
export const ROLLUP_MODE_OPTIONS = [
  { value: SHOW_ALL_QUESTIONS, label: 'Show all answers' },
  { value: SHOW_ONLY_PINNED, label: 'Only show pinned answers' },
  { value: SHOW_WORKBOOK, label: 'Show original Workbook' },
];

const GradientSelect = ({ options, selected, onChange }) => (
  <div className="select-container">
    <select onChange={onChange} value={selected}>
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
    <span className="arrow">
      <ArrowDownIcon />
    </span>
  </div>
);

export const BlockSelector = ({
  template: { blocks },
  selectBlock,
  activeBlock,
}) => {
  const enrichedBlocks = React.useMemo(
    () => processLayoutBlocks(blocks),
    [blocks]
  );
  const options = enrichedBlocks
    .filter((block) => block.questionString)
    .map((block) => ({ value: block.uuid, label: block.questionString }));

  // this can't be null; React will end up using the label as the option value
  options.unshift({ value: SHOW_ALL_QUESTIONS, label: 'All Questions' });

  const onChange = (e) => {
    if (e.target.value === SHOW_ALL_QUESTIONS) {
      selectBlock(null);
    } else {
      selectBlock(e.target.value);
    }
  };

  return (
    <GradientSelect
      options={options}
      selected={activeBlock || SHOW_ALL_QUESTIONS}
      onChange={onChange}
    />
  );
};

export const ShowModeSelector = ({ setShowMode, showMode }) => (
  <GradientSelect
    options={ROLLUP_MODE_OPTIONS}
    selected={showMode || SHOW_ALL_QUESTIONS}
    onChange={(e) => {
      setShowMode(e.target.value);
    }}
  />
);
